import {
    BANKNAMELISTPARTNER_SUCCESS,
    BANKNAMELISTPARTNER_FAILED,
    RESET_BANKNAMELISTPARTNER,
    LOADING_BANKNAMELISTPARTNER,
    NETWORK_ERROR_BANKNAMELISTPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetBankNameListForPartner = () => {
    return { type: RESET_BANKNAMELISTPARTNER };
};


const partnerBankNameListReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKNAMELISTPARTNER });
    await partnerServices
        .post("banknameListpartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerBankNameListReqsuccess(res.data));
                    break;
                default:
                    dispatch(partnerBankNameListReqFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BANKNAMELISTPARTNER,
                payload: err
            });
        });
};


function partnerBankNameListReqsuccess(data) {
    return {
        type: BANKNAMELISTPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerBankNameListReqFailed(data) {
    return {
        type: BANKNAMELISTPARTNER_FAILED,
        payload: data,
    };
}


export { resetBankNameListForPartner, partnerBankNameListReqList }